// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import './assets/style.css'
import axios from 'axios'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.prototype.appSet = {
  appid:'5f0eae155aae7',
  appkey:'5f0eae155aaed'
};

import {message,Layout,Menu,Icon, Dropdown, Table, Breadcrumb, Select, Input, Pagination, Spin, Modal, Form, DatePicker, Radio, InputNumber, Tag, Divider, Button, Descriptions, Timeline, Empty, Carousel, Switch, Upload, Row, Col, Checkbox, Tree, Tabs, Cascader, Progress, Card, Badge, Tooltip} from 'ant-design-vue';

Vue.use(Layout)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Dropdown)
Vue.use(Table)
Vue.use(Breadcrumb)
Vue.use(Select)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Spin)
Vue.use(Modal)
Vue.use(Form)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(InputNumber)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Button)
Vue.use(Descriptions)
Vue.use(Timeline)
Vue.use(Empty)
Vue.use(Carousel)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Row)
Vue.use(Col)
Vue.use(Checkbox)
Vue.use(Tree)
Vue.use(Tabs)
Vue.use(Cascader)
Vue.use(Progress)
Vue.use(Card)
Vue.use(Badge)
Vue.use(Tooltip)

Vue.prototype.$message=message
// Vue.prototype.$message = message;



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js